<template>
  <div>
    <PageTitle>
      <b-container>
        <h1 class="display-3">{{ project.project_name }}</h1>
        <p class="lead">
          Download the inputs template, fill it in with the project details, and
          upload it to this page to run a CBA
        </p>
        <b-button
          variant="primary"
          href="/SINSW CBA Tool Input Template.xlsm"
          download
        >
          Download inputs template
        </b-button>
        <b-icon-blank />
        <b-button
          @click="download_latest_inputs"
          variant="primary"
          :disabled="no_latest_inputs"
        >
          Download latest inputs and results
        </b-button>
      </b-container>
    </PageTitle>
    <b-overlay :show="loading" rounded="sm" no-wrap fixed />
    <b-container>
      <b-row>
        <b-col>
          <b-card no-body>
            <template v-slot:header>
              <b-card-title
                class="d-flex justify-content-between align-items-center"
              >
                {{ project.project_name }}
              </b-card-title>
              <b-card-sub-title>
                {{ project.school_name }} ({{ project.school_scg }})
              </b-card-sub-title>
            </template>
            <b-card-body>
              <b-card-text>
                <b-alert
                  v-for="err in data_errors"
                  :key="err"
                  show
                  variant="danger"
                >
                  {{ err }}
                </b-alert>
                <!-- <vue-csv-import
                  :autoMatchFields="true"
                  :autoMatchIgnoreCase="true"
                  url="/"
                  v-model="csv"
                  :mapFields="input_fields"
                  :headers="true"
                  :canIgnore="false"
                  tableClass="table b-table table-striped table-hover border"
                  checkboxClass="custom-control-input"
                  buttonClass="btn btn-primary btn-block"
                  inputClass="custom-file-input"
                  @input="submit($event)"
                >
                </vue-csv-import> -->
                <vue-file-upload
                  :autoMatchFields="true"
                  :autoMatchIgnoreCase="true"
                  url="/"
                  v-model="csv"
                  :mapFields="input_fields"
                  :headers="true"
                  :canIgnore="false"
                  tableClass="table b-table table-striped table-hover border"
                  checkboxClass="custom-control-input"
                  buttonClass="btn btn-primary btn-block"
                  inputClass="custom-file-input"
                  @input="submit($event)"
                >
                </vue-file-upload>
              </b-card-text>
            </b-card-body>
          </b-card>
        </b-col>
      </b-row>
      <br />
      <b-row v-if="items != null && items.length > 0">
        <b-col>
          <h4>Latest Results</h4>
          <Table :filter_toggle="false" :fields="fields" :items="items">
          </Table>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import PageTitle from "@/components/PageTitle.vue";
import Table from "@/components/Table.vue";
// import VueCsvImport from "@/components/VueCsvImport.vue";
import VueFileUpload from "@/components/VueFileUpload.vue";
// import FileSaver from "file-saver";

export default {
  name: "ProjectSubmit",
  components: {
    PageTitle,
    Table,
    // VueCsvImport,
    VueFileUpload,
  },
  props: {},
  data() {
    return {
      loading: true,
      csv: null,
      input_fields: {
        input_name: {
          label: "Input name",
          required: true,
        },
        school: {
          label: "School",
          required: true,
        },
        option: {
          label: "Option",
          required: true,
        },
        supplementary_attribute: {
          label: "Supplementary attribute",
          required: true,
        },
        year: {
          label: "Year",
          required: true,
        },
        value: {
          label: "Value",
          required: true,
        },
      },
      fields: [
        {
          key: "timestamp",
          label: "Date",
          sortable: true,
        },
        // {
        //   key: "consultant",
        //   label: "Consultant",
        //   sortable: true,
        // },
        {
          key: "option_name",
          label: "Option Name",
          sortable: true,
        },
        {
          key: "npv",
          format: "$0,0",
          label: "NPV",
          sortable: true,
        },
        {
          key: "bcr",
          format: "0.[00]",
          label: "BCR",
          sortable: true,
        },
      ],
      items: [
        // {
        //   timestamp: "19 Nov 2021",
        //   consultant: "SGS Economics and Planning",
        //   option_name: "Base Case",
        //   npv: "120000",
        //   bcr: "1.5",
        // },
        // {
        //   timestamp: "22 Nov 2021",
        //   consultant: "SGS Economics and Planning",
        //   option_name: "Light Refurbishment",
        //   npv: "352000",
        //   bcr: "2.5",
        // },
      ],
      filteredItems: [],
      selectMultiple: false,
      show: false,
      project: {
        last_submitted_filename: null,
      },
      data_errors: [],
    };
  },
  computed: {
    no_latest_inputs() {
      return this.project.last_submitted_filename == null;
    },
  },
  methods: {
    get_project() {
      this.loading = true;
      this.$store
        .dispatch("get", {
          url: "/project/" + this.$route.params.id,
        })
        .then((response) => {
          this.loading = false;
          console.log(response.data);
          this.last_submitted_filename;
          this.project = response.data.data;
          this.items = response.data.options;
        })
        .catch((error) => {
          this.loading = false;
          console.log(error.response.data);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    download_latest_inputs() {
      this.loading = true;
      this.$store
        .dispatch("get_blob", {
          url: "/project/download/inputs/" + this.$route.params.id,
        })
        .then((response) => {
          this.loading = false;
          console.log(response.data);
          let url = window.URL.createObjectURL(response.data);
          let link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", this.project.last_submitted_filename);
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          this.loading = false;
        })
        .catch((error) => {
          this.loading = false;
          console.log(error.response.data);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    submit(event) {
      // console.log(event);
      this.loading = true;
      this.$store
        .dispatch("post_blob", {
          data: event,
          url: "/project/submit/xlsb/" + this.$route.params.id,
        })
        .then((response) => {
          console.log(response);
          this.project.last_submitted_filename = response.data.filename;
          this.download_latest_inputs();
        })
        .catch((error) => {
          this.loading = false;
          console.log(error.response.data);
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
  mounted() {
    this.get_project();
  },
  created() {},
};
</script>
